import { FieldProps } from 'formik'
import {
  ComboBox,
  IComboBoxOption,
  IComboBoxProps,
  IDropdownOption,
} from 'office-ui-fabric-react'
import * as React from 'react'

export type FormikComboBoxProps = FieldProps<any> & {
  options: IDropdownOption[] | IComboBoxOption[]
} & Omit<IComboBoxProps, 'options' | 'autoComplete'>

export class FormikComboBox extends React.Component<FormikComboBoxProps> {
  private options: IComboBoxOption[] = []
  private initialValue: string = ''

  constructor(props: FormikComboBoxProps) {
    super(props)
    this._createOptions(props)
    this.initialValue = props.field.value
  }

  public componentWillReceiveProps(nextProps: FormikComboBoxProps) {
    this._createOptions(nextProps)
    this.initialValue = nextProps.field.value
  }

  public render(): JSX.Element {
    const opt = this.options.find((op) => op.key === this.initialValue)
    const text = opt ? opt.text : this.props.field.value
    return (
      <ComboBox
        {...this.props}
        useComboBoxAsMenuWidth={true}
        autoComplete={'on'}
        text={text}
        options={this.options}
        onChange={(_, option, __, val) => {
          if (this.props.onChange) {
            this.props.onChange(_, option, __, val)
          }
          if (option) {
            this.props.form.setFieldValue(this.props.field.name, option.key)
          } else if (val) {
            this.props.form.setFieldValue(this.props.field.name, val)
          } else {
            this.props.form.setFieldValue(this.props.field.name, null)
          }
        }}
      />
    )
  }

  private _createOptions(props: FormikComboBoxProps) {
    this.options = props.options
  }
}
